import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { OfficeWorkload } from '@office-start/officehome-types';
import { fetchWebStorageGetUserItem } from '@office-start/web-storage-utility';
import { HARMONY_THEME_USER_STORAGE_KEY } from '../model/harmonyThemeUserStorage';
import { fetchGetHarmonyThemeUserStorage } from './fetchGetHarmonyThemeUserStorage';
export var fetchHarmonyTheme = function () { return __awaiter(void 0, void 0, void 0, function () {
    var componentContext, themeDataDesktop;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
            case 1:
                componentContext = _a.sent();
                if (!componentContext) {
                    return [2 /*return*/, {
                            result: null,
                            fromPersistence: false,
                        }];
                }
                if (!(componentContext.workload === OfficeWorkload.Hwa)) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchWebStorageGetUserItem(HARMONY_THEME_USER_STORAGE_KEY)];
            case 2:
                themeDataDesktop = _a.sent();
                return [2 /*return*/, {
                        result: themeDataDesktop,
                        fromPersistence: themeDataDesktop !== undefined,
                    }];
            case 3: return [2 /*return*/, fetchGetHarmonyThemeUserStorage(HARMONY_THEME_USER_STORAGE_KEY)];
        }
    });
}); };
//# sourceMappingURL=fetchHarmonyTheme.js.map